import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { sendAcquireMultipleAsset } from '@api/assets';

import { IAcquireMultipleAssetDTO } from '@interfaces/map/dto/mapDTO';

import { ESnackbarTypes } from '@enums/common';

import {
	ACQUIRE_ASSET,
	ASSET_CART_REQUEST_AVAILABLE,
	ASSET_CART_REQUEST_COUNT,
	ASSET_CART_REQUEST_DROPDOWN,
	ASSET_CART_REQUEST_UNAVAILABLE,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSendAcquireMultipleAssets = (onSuccessCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleSendAcquireMultipleAsset,
		isLoading: isSendingAcquireMultipleAsset,
	} = useMutation<IAcquireMultipleAssetDTO>({
		mutationKey: [ACQUIRE_ASSET],
		mutationFn: sendAcquireMultipleAsset,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.sendAcquireAsset,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks?.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}

			return [
				queryClient.invalidateQueries([ASSET_CART_REQUEST_COUNT]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_DROPDOWN]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_AVAILABLE]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_UNAVAILABLE]),
			];
		},
	});

	return {
		isSendingAcquireMultipleAsset,
		handleSendAcquireMultipleAsset,
	};
};
